import { Col, Form, Input, Row, Space } from "antd";
import React, { useEffect, useState } from "react";
import { ButtonUi } from "../ui/ButtonUi";
import { TipoButtonConstants } from "../../types/typesConstants";
import { FormUi } from "../ui/FormUi";
import { productoStartLoading } from "../../actions/producto";
import { useDispatch } from "react-redux";
import { CategoriaProductoSelect, TiposItemSelect } from "./reusable";

const initialValues = {
  nombre: null,
  categoriaitem: null,
  tipoitem: null,
};

export const ProductoSearchFormTable = () => {
  const [form] = Form.useForm();
  const [moreSearch, setMoreSearch] = useState(false);
  const dispatch = useDispatch();
  useEffect(() => {
    if (!moreSearch) {
      form.setFieldsValue({ categoriaitem: null, tipoitem: null });
    }
  }, [moreSearch]);

  const handleMoreFieldSearch = () => setMoreSearch(!moreSearch);
  const handleSubmit = (values) => {
    let valueData = {};
    if (values?.nombre) valueData = { ...valueData, nombre: values?.nombre };
    if (values?.categoriaitem)
      valueData = { ...valueData, categoriaitem: values?.categoriaitem };
    if (values?.tipoitem)
      valueData = { ...valueData, tipoitem: values?.tipoitem };
    localStorage.setItem("SearhFormTable", JSON.stringify(valueData));
    dispatch(productoStartLoading({ ...valueData }));
  };
  return (
    <FormUi
      form={form}
      name="advanced_search"
      className="ant-advanced-search-form"
      initialValues={initialValues}
      handleSubmit={handleSubmit}
      layout="vertical"
    >
      {moreSearch && (
        <Row gutter={[8, 8]}>
          <Col xs={24} sm={24} md={8} lg={6} xl={6}>
            <Form.Item name="categoriaitem" label="Categoria">
              <CategoriaProductoSelect placeholder="[-TODOS-]" allowClear />
            </Form.Item>
          </Col>

          <Col xs={24} sm={24} md={8} lg={6} xl={6}>
            <Form.Item name="tipoitem" label="Tipo item">
              <TiposItemSelect placeholder="[-TODOS-]" allowClear />
            </Form.Item>
          </Col>
        </Row>
      )}
      <Row gutter={[8, 8]}>
        <Col xs={24} sm={24} md={12} lg={10} xl={9}>
          <Form.Item
            name="nombre"
            label="Buscar por nombre"
            layout="horizontal"
          >
            <Input placeholder="Buscar nombre del item" />
          </Form.Item>
        </Col>
        <Col xs={12} sm={12} md={8} lg={4} xl={4}>
          <Space>
            <ButtonUi
              typeUi={TipoButtonConstants.Buscar}
              htmlType="submit"
              text="Consultar"
            />
            <ButtonUi
              typeUi={TipoButtonConstants.Filtrar}
              onClick={handleMoreFieldSearch}
              displayText={false}
            />
          </Space>
        </Col>
      </Row>
    </FormUi>
  );
};
